import api from "./Api";

class PedidoEnderecoService {
  GetPedidoEndereco(payload) {
    return api.get("/v1/pedidoEndereco/" + payload).then((response) => {
      return response.data;
    });
  }

  PostPedidoEndereco(payload) {
    return api.post("/v1/pedidoEndereco/", payload).then((response) => {
      return response.data;
    });
  }

  PutPedidoEndereco(payload) {
    return api.put("/v1/pedidoEndereco/", payload).then((response) => {
      return response.data;
    });
  }

  DeletePedidoEndereco(payload) {
    return api.delete("/v1/pedidoEndereco/" + payload).then((response) => {
      return response.data;
    });
  }

  GetPedidoEnderecoOData(payload) {
    return api.get("/OData/PedidoEndereco" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new PedidoEnderecoService();
